import './App.css';
import Home from './pages/Home/Home';

function App() {
  return (
<Home></Home>
  );
}

export default App;
